module.exports = __webpack_public_path__ + "img/2.d76edff3.jpg";